import ls from 'localstorage-slim';
import { Sections } from '../types/Sections';
import { isSixInHash } from './isSixInHash';
import { MenuItems } from '../types/MenuItems';
import { isMenuPageOpen } from './isMenuPageOpen';

export const togglePage = (newHash: string) => {
  const { hash } = window.location;

  if (hash.split('-')[1] === 'page') {
    ls.set('prevSixSection', window.location.hash);
  }

  if (window.location.hash === newHash) {
    const activeMainSection: string | null = ls.get('activeMainSection');

    window.location.hash = activeMainSection || '/';
  } else {
    if (
      hash.includes(Sections.EASYBUY) ||
      hash.includes(Sections.ADVANTAGES) ||
      hash.includes(Sections.SIXINTIX)
    ) {
      ls.set('activeMainSection', window.location.hash);
    }

    if (isSixInHash()) {
      ls.set('prevSixPage', window.location.hash);
    }

    if (isMenuPageOpen()) {
      ls.set('prevMenuPage', window.location.hash);
    }

    window.location.hash = newHash;
  }
};
